module.exports = __webpack_public_path__ + "static/media/discover.a0c18c9b.svg";